import { useTranslation } from 'react-i18next'

import { Divider, Text } from '@reveni-io/reveni-ui'

import ShippingMethods from './ShippingMethods/ShippingMethods'

const AvailabilityCriterionUsedIn = ({ criterionId, shippingMethods, regions, loading }) => {
  const { t } = useTranslation()

  if (criterionId === 'new' || criterionId?.startsWith('duplicate-')) return null

  return (
    <>
      <Divider />
      <Text type="titleM">{t('Criterios usados en')}:</Text>
      <ShippingMethods shippingMethods={shippingMethods} regions={regions} loading={loading} />
    </>
  )
}

export default AvailabilityCriterionUsedIn
